export const PageNotFound = () => (
    <div class="box">
        <h1 class="title">404</h1>
        <p>This is page could not be located.</p>
    </div>
    );